import Reflux from 'reflux';
import { Map, OrderedMap, fromJS } from 'immutable';
import BaseMixin from 'flux/stores/BaseMixin';
import EventCrewListActions from 'flux/actions/EventCrewListActions';
import RealTimeActions from 'flux/actions/RealTimeActions';
import CrewListMixin from 'flux/stores/CrewListMixin';

/**
 * EventCrewListStore
 *
 */
export default Reflux.createStore({
  listenables: [EventCrewListActions, RealTimeActions],

  mixins: [BaseMixin, CrewListMixin],

  init() {
    this.setState(Map({ list: OrderedMap([]) }));
  },

  onPopulate(teamId, eventId) {
    this.setStateAndTrigger(
      this.getState().set('teamId', teamId).set('eventId', eventId),
    );
  },

  // eslint-disable-next-line no-unused-vars
  onPopulateFailed(err) {
    //TODO..
  },

  onPopulateCompleted(users) {
    this.setInStateAndTrigger('list', this.getOrderedUserMap(users));
  },

  onUpdateRole(teamId, eventId, userId, roleId, newRole) {
    this._updateRole(eventId, userId, fromJS(newRole));
  },

  _updateRole(eventId, userId, newRole) {
    this.setStateAndTrigger(
      this.getState().updateIn(['list', userId], (userMap) => {
        let eventRoles = userMap.get('events');
        let eventIndex = eventRoles.findIndex(
          (eventRole) => eventRole.get('event') === eventId,
        );
        eventRoles = eventRoles.setIn([eventIndex, 'role'], fromJS(newRole));
        return userMap.set('events', eventRoles);
      }),
    );
  },

  onCreateRoleCompleted(updatedUser) {
    this.setInStateAndTrigger(['list', updatedUser._id], fromJS(updatedUser));
  },

  onRemoveRole(teamId, eventId, userId) {
    let user = this.getInState(['list', userId]);

    let isTeamAdmin = user
      .get('teams')
      .find((teamRole) => teamRole.get('team') === teamId);
    /**
     * If they are a team admin, don't delete them from the list, just remove their event perm
     */
    if (isTeamAdmin) {
      return this.setStateAndTrigger(
        this.getState().updateIn(['list', userId, 'events'], (events) => {
          return events.filter((eventRole) => {
            return eventRole.get('event') !== eventId;
          });
        }),
      );
    }

    this.removeRoleEphemeral(userId);
  },

  onEventUpdateRoleRealTime({ eventId }, { userId, role }) {
    if (eventId !== this.getInState('eventId')) return;

    this._updateRole(eventId, userId, fromJS(role));
  },
});
